import React from 'react';

interface AppendexIconProps {
  className?: string;
}

const AppendexIcon: React.FC<AppendexIconProps> = ({ className = "h-8 w-8" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Document principal avec coin plié */}
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <animate
        attributeName="opacity"
        values="0.7; 1; 0.7"
        dur="2s"
        repeatCount="indefinite"
      />
    </path>

    {/* Coin plié */}
    <polyline
      points="14 2 14 8 20 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <animate
        attributeName="opacity"
        values="0.7; 1; 0.7"
        dur="2s"
        repeatCount="indefinite"
      />
    </polyline>

    {/* Lignes de texte */}
    <line x1="8" y1="13" x2="16" y2="13" stroke="currentColor" strokeWidth="1.5" opacity="0.5" strokeLinecap="round" />
    <line x1="8" y1="17" x2="13" y2="17" stroke="currentColor" strokeWidth="1.5" opacity="0.5" strokeLinecap="round" />

    {/* Badge Plus animé */}
    <circle
      cx="17"
      cy="19"
      r="4"
      fill="currentColor"
      stroke="none"
    >
      <animate
        attributeName="r"
        values="4; 4.3; 4"
        dur="2s"
        repeatCount="indefinite"
      />
    </circle>

    {/* Symbole + en blanc */}
    <line x1="17" y1="17" x2="17" y2="21" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="15" y1="19" x2="19" y2="19" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export default AppendexIcon;
